
import './NewsCard.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBriefcase, faBullhorn, faInfoCircle, faUserPlus, faWarning } from '@fortawesome/free-solid-svg-icons'


export default function NewsCard(props) {
    return (
        <a
            href={'/news/' + props.newsid}
            className={'newscard noselect ' + props.className}
            style={{ textDecoration: 'none', color: 'inherit' }}
        >
            {
                (props.type == 'warn') ?
                    <FontAwesomeIcon className='newscardicon newscard_warn' icon={faWarning} />
                    : (props.type == 'job') ?
                        <FontAwesomeIcon className='newscardicon newscard_job' icon={faUserPlus} />
                        : (props.type == 'announcement') ?
                            <FontAwesomeIcon className='newscardicon newscard_announcement' icon={faBullhorn} />
                            : (props.type == 'project') ?
                                <FontAwesomeIcon className='newscardicon newscard_project' icon={faBriefcase} />
                                :
                                <FontAwesomeIcon className='newscardicon newscard_info' icon={faInfoCircle} />
            }
            <div className='newscardtextcont'>
                <b>{props.title}</b>
                <p>{props.datum} ● {props.subtitle}</p>
            </div>

        </a>
    )
}
